import { render, staticRenderFns } from "./CompareSimilarProductCard.vue?vue&type=template&id=2135c3bb"
import script from "./CompareSimilarProductCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareSimilarProductCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompareSimilarProductCard.vue?vue&type=style&index=0&id=2135c3bb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports